
function createGestureGuard(map, mapContainer, config) {
    const gestureHint = document.createElement("div");
    gestureHint.className = "dealerSearchMap__gestureHint";
    mapContainer.appendChild(gestureHint);

    let gestureHintTimeout = null;
    const showGestureHint = (text) => {
        gestureHint.textContent = text;
        gestureHint.classList.add("is-visible");
        clearTimeout(gestureHintTimeout);
        gestureHintTimeout = setTimeout(() => gestureHint.classList.remove("is-visible"), 1500);
    };
    const hideGestureHint = () => {
        clearTimeout(gestureHintTimeout);
        gestureHint.classList.remove("is-visible");
    };

    if (window.matchMedia("(pointer: coarse)").matches) {
        const touchHintText = config.gestureHintText || "Mit zwei Fingern bewegen";

        const guardDragging = () => {
            map.dragging.disable();
            mapContainer.style.touchAction = "pan-y";
        };

        guardDragging();

        mapContainer.addEventListener("touchstart", (event) => {
            if (event.touches.length >= 2) {
                hideGestureHint();
                map.dragging.enable();
                mapContainer.style.touchAction = "none";
            } else {
                guardDragging();
                showGestureHint(touchHintText);
            }
        }, {passive: true});

        ["touchend", "touchcancel"].forEach(type => {
            mapContainer.addEventListener(type, (event) => {
                if (event.touches.length < 2) {
                    guardDragging();
                }
            }, {passive: true});
        });
    }

    const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
    const scrollHintText = config.scrollHintText
        || (isMac ? "⌘ + Scrollen zum Zoomen" : "Strg + Scrollen zum Zoomen");

    mapContainer.addEventListener("wheel", (event) => {
        if (event.ctrlKey || event.metaKey) {
            return;
        }
        event.stopPropagation();
        showGestureHint(scrollHintText);
    }, {capture: true});
}

// Sets up the Leaflet map (centered on the last search, falling back to a
// Switzerland-wide view), tile layer, marker cluster, marker icons, and the
// gesture guard. Returns everything the list/render module needs.
export function createDealerMap(mapContainer, config) {
    const latitude = parseFloat(config.latitude);
    const longitude = parseFloat(config.longitude);
    const initialView = (!isNaN(latitude) && !isNaN(longitude)) ? [latitude, longitude] : [46.8, 8.23];

    const map = L.map(mapContainer).setView(initialView, 8);
    map.zoomControl.remove();
    L.control.zoom({position: "topleft"}).addTo(map);
    document.querySelectorAll(".leaflet-control-zoom a").forEach(button => button.removeAttribute("href"));
    // CARTO requires an API key since 2026-08; tiles without one are served with an
    // "API KEY REQUIRED" watermark. The key comes from CARTO_BASEMAP_KEY in config/.env
    // via the theme entry file, so it can be rotated without rebuilding the bundle.
    const tileKey = (window.mhgMapConfig && window.mhgMapConfig.tileKey) || "";
    const tileUrl = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
        + (tileKey ? "?key=" + encodeURIComponent(tileKey) : "");
    L.tileLayer(tileUrl, {
        attribution: "&copy; <a href=\"https://carto.com/attributions\">CARTO</a>, &copy; OpenStreetMap contributors"
    }).addTo(map);

    createGestureGuard(map, mapContainer, config);

    const markerCluster = L.markerClusterGroup();
    map.addLayer(markerCluster);

    return {
        map,
        markerCluster,
        markerIconDefault: L.AwesomeMarkers.icon({markerColor: "blue"}),
        markerIconActive: L.AwesomeMarkers.icon({markerColor: "red"})
    };
}
